import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import createNotificationServiceClient from '@swf/core/gql/clients/createNotificationServiceClient';
import useNotificationSubscription from '@swf/core/gql/hooks/useNotificationSubscription';
import { select } from '@swf/core/store';

const NotificationServiceSubscriptions = () => {
  const { idpToken = '' } = useSelector(select.session.get);
  const client = useMemo(() => createNotificationServiceClient(idpToken), [idpToken]);

  useNotificationSubscription(client);

  return null;
};

export default NotificationServiceSubscriptions;
